import React from 'react';
import { Circle, Path, Svg } from 'react-native-svg';
import type { SvgProps } from 'react-native-svg';
import { useUnistyles } from 'react-native-unistyles';

import type { AppColors } from '@squire/ui';

export interface RemoveIconProps extends SvgProps {
  size?: number;
  color?: keyof AppColors;
}

export const RemoveIcon: React.FC<RemoveIconProps> = ({
  size = 16,
  color = 'textLink',
}) => {
  const { theme: colors } = useUnistyles();
  const strokeColor = colors[color];

  return (
    <Svg width={size} height={size} viewBox="0 0 16 16" fill="none">
      <Circle cx="8" cy="8" r="7.35" stroke={strokeColor} strokeWidth={1.3} />
      <Path
        d="M5.87869 5.87867L10.1213 10.1213"
        stroke={strokeColor}
        strokeWidth={1.3}
        strokeLinecap="round"
      />
      <Path
        d="M10.1213 5.87867L5.87867 10.1213"
        stroke={strokeColor}
        strokeWidth={1.3}
        strokeLinecap="round"
      />
    </Svg>
  );
};

RemoveIcon.displayName = 'RemoveIcon';
